import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { useCategoryTreeItem } from '../categoryTree';

import { createLastWatchedQueryOptions } from './queryOptions';
import { LastWatched } from './types';
import { createLastWatched } from './utils';

type UseLastWatchedProps = {
  pageReferenceId: string | undefined;
  referenceId: string;
  enabled: boolean;
};

export function useLastWatched({ pageReferenceId, referenceId, enabled }: UseLastWatchedProps) {
  const category = useCategoryTreeItem(referenceId);

  const { data, error, isLoading } = useQuery({
    ...createLastWatchedQueryOptions(),
    enabled,
  });

  const lastWatched = useMemo<LastWatched | undefined>(() => {
    if (!data || !pageReferenceId || !category) {
      return;
    }

    return createLastWatched({
      defaultChannelId: category.railProperty.defaultChannel,
      lastWatchedData: data,
      pageReferenceId,
    });
  }, [data, category, pageReferenceId]);

  return {
    isLoading: Boolean(category) && isLoading,
    lastWatched,
    error,
  };
}
